<lx-card-container
  *ngIf="premiumAccommodation?.code || loading()"
  type="accommodation"
  title="Premium Accommodation"
  i18n-title
  [loading]="loading()"
  [disabled]="!selectedPremiumAccommodationCode"
  [endPrice]="endPrice"
  [price]="price"
  [currency]="currency?.()"
  [discount]="discount"
  [actionMode]="selectedPremiumAccommodationCode ? 'remove' : 'add'"
  [footerVisible]="!!premiumAccommodation?.multiCurrencyPrice"
  [gaEventName]="dataLayerEventName$ | async"
  (buttonClick)="addOrRemovePremiumAccommodation(premiumAccommodation?.code)"
  data-qa="premiumAccommodation_cardContainer"
>
  <div class="premium-accommodation">
    <div class="extra-card">
      <lx-image
        class="extra-card__image"
        [image]="PREMIUM_ACCOMMODATIONS_FALLBACK_IMAGE"
        [fallbackImage]="PREMIUM_ACCOMMODATIONS_FALLBACK_IMAGE"
        [width]="280"
        [height]="180"
        alt="Premium Accommodation"
      />
      <div class="extra-card__content">
        <div class="extra-card__content__text" i18n>Upgrade your accommodation and enjoy more privacy and comfort while you study.</div>
        <lx-button (buttonClick)="onLearnMoreClick()" [buttonStyle]="'link'" data-qa="premiumAccommodation_learnMore" i18n-text text="Learn more"></lx-button>
        <div class="card-container-highlighted" *ngIf="selectedPremiumAccommodationCode">{{ duration | lxLocalizeAndPluralizePeriod }}</div>
      </div>
    </div>
    <lx-option-card
      class="premium-accommodation__checkbox"
      *ngIf="!premiumAccommodation?.multiCurrencyPrice"
      [type]="'checkbox'"
      data-qa="premiumAccommodation_addToMyStay"
      i18n-title
      title="Add to my stay"
      [withImage]="false"
      [selectedOption]="selected"
      (selectedOptionChanged)="addOrRemoveCode()"
    ></lx-option-card>
  </div>
</lx-card-container>

<lx-side-panel-gallery
  [visible]="premiumAccommodationDialogVisible"
  (hiddenPanel)="hidePremiumAccommodationDialog()"
  data-qa="premiumAccommodation_sidePanel"
  [images]="premiumAccommodation?.galleryUrls"
>
  <div class="premium-accommodation__details">
    <h3 class="premium-accommodation__details__title" data-qa="premiumAccommodation_details_title" i18n>Single Ensuite Residence</h3>

    <ul class="premium-accommodation__details__options">
      <li class="premium-accommodation__details__options__shared-room" data-qa="premiumAccommodation_details_roomType">
        {{ premiumAccommodation?.roomType }}
      </li>
      <li class="premium-accommodation__details__options__shared-bathroom" data-qa="premiumAccommodation_details_bathroom">
        {{ premiumAccommodation?.bathroomType }}
      </li>
    </ul>

    <div class="premium-accommodation__details__description" data-qa="premiumAccommodation_details_description">
      {{ premiumAccommodation?.description }}
    </div>
  </div>
</lx-side-panel-gallery>
